module.exports = __webpack_public_path__ + "img/estamos_preparados2.ac96c82d.svg";